import React from "react";
import Header from "../../Header/Header";
import HomeInspectorConfirmation from "./../../../assets/images/HomeInspectorConfirmation.png";
import { useNavigate } from "react-router-dom";
const TitleServiceConfirmation = () => {
    const navigate = useNavigate();
    return (
        <div className="tw-min-h-screen tw-pt-[65px] tw-h-full tw-bg-background_color tw-overflow-auto">
            <span className="">
                <Header title="Insurance Services Confirmation" />
            </span>
            <div className="tw-max-w-full tw-h-full tw-mx-auto tw-flex tw-flex-col tw-items-center tw-justify-between ">
                <div></div>
                <div className="tw-flex  tw-flex-col tw-max-w-[70%] max-sm:tw-max-w-full max-md:tw-max-w-[90%] md:tw-bg-white  tw-rounded-xl tw-w-full ">
                    <div className="tw-flex tw-justify-center tw-mt-3">
                        <img src={HomeInspectorConfirmation} className="tw-w-[150px]" alt="" />
                    </div>

                    <div className="tw-rounded-lg tw-py-8 tw-flex tw-flex-col tw-gap-5 max-md:tw-px-8 tw-px-16 max-sm:tw-px-5 ">
                        <div className="tw-text-center">
                            <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-2 ">Title Service Request Confirmed</h1>
                            <p className="tw-text-gray-600 tw-text-[16px] tw-font-medium">
                                Thank you for choosing us! Your title service request is now in progress.
                            </p>
                        </div>

                        <div>
                            <h2 className="tw-font-semibold tw-text-[18px] tw-pb-3">What Happens Next?</h2>
                            <ul className="tw-list-disc tw-ml-5">
                                <li>A title professional will review your request within one business day.</li>
                                <li>You’ll receive an email with next steps and any required documentation.</li>
                                <li>Our team will initiate the title search and prepare requested services.</li>
                            </ul>
                        </div>

                        <div>
                            <h2 className="tw-font-semibold tw-text-[18px] tw-pb-3">Next Steps</h2>
                            <ul className="tw-list-disc tw-ml-5">
                                <li>Check your email for confirmation and a welcome packet.</li>
                                <li>Gather any necessary documents.</li>
                                <li>Mark your calendar for the closing date. </li>
                            </ul>
                        </div>

                        <div className="tw-flex tw-flex-col tw-items-center lg:tw-flex-nowrap tw-gap-4">
                            <button
                                onClick={() => {
                                    sessionStorage.removeItem("insuranceInfo");
                                    navigate("/properties");
                                }}
                                className="tw-bg-primary hover:tw-bg-primary_hover tw-w-fit tw-px-[100px] tw-text-white tw-h-[52px] tw-rounded-lg tw-transition-colors tw-text-sm"
                            >
                                Return To Home Screen
                            </button>
                            <p className="tw-text-gray-700 tw-text-center">
                                Keep this confirmation for reference. If you have any questions, feel free to reach out. We're here to ensure a
                                smooth, secure transaction!{" "}
                            </p>
                        </div>
                    </div>
                </div>
                <div></div>
            </div>
        </div>
    );
};

export default TitleServiceConfirmation;
